export const MODAL_PORTAL = 'modal-portal-host';
export const FLYOUT_PORTAL = 'flyout-portal-host';
export const TOAST_PORTAL = 'toast-portal-host';
export const DRAWER_PORTAL = 'drawer-portal-host';
